import { render, staticRenderFns } from "./AddReservation.vue?vue&type=template&id=c251ff24"
import script from "./AddReservation.vue?vue&type=script&lang=js"
export * from "./AddReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports